import { DailySummaryDto } from '@peartherapeutics/hylia-api-client';
import moment from 'moment';

/** filter for only summaries containing Triggers data */
export const selectWithTriggers = (
  dailies: DailySummaryDto[],
): DailySummaryDto[] =>
  dailies.filter((summary) => summary.triggers.length > 0);

/** Filter for dailySummaries. If only 'keyDate' provided, this will bound the filter
 * to the starting and ending dates for the week of the 'keyDate'.  If an 'endDate' is also
 * provided, this will set the  filter's boundaries from the 'keyDate' to the 'endDate' instead
 * */
export const selectFilteredDates = (props: {
  dailies: DailySummaryDto[];

  /** if ONLY a keyDate provided, will bound with the start and end of that week */
  keyDate: string;

  /** if keyDate AND endDate provided, they will be used as start-end boundaries for the filter */
  endDate?: string;
}): DailySummaryDto[] => {
  const { dailies, keyDate, endDate } = props;
  // guard clause
  if (!dailies || dailies.length < 0 || !keyDate) return [];

  const starting = endDate ? keyDate : moment(keyDate).startOf('week');
  const ending = endDate || moment(keyDate).endOf('week');

  /** filter for summaries falling within the week of the keyDate */
  return dailies.filter((summary) =>
    moment(summary.date).isBetween(starting, ending, 'day', '[]'),
  );
};

/** Finds the average intensity, rounded to 1 decimal, across an array of dailySummaries. */
export const selectAverageIntensity = (dailies: DailySummaryDto[]): number => {
  // guard clause
  if (!dailies || dailies.length < 1) return 0;

  const sum = dailies
    .map((summary) => summary.averageCravingIntensity)
    .reduce((sum: number, intensity: number) => sum + intensity);
  return Math.round((sum / dailies.length) * 10) / 10;
};
